var MediaSize = /*#__PURE__*/function (MediaSize) {
  MediaSize["XSmall"] = "x-small";
  MediaSize["Small"] = "small";
  MediaSize["Regular"] = "regular";
  MediaSize["Medium"] = "medium";
  MediaSize["Large"] = "large";
  MediaSize["XLarge"] = "x-large";
  MediaSize["X2Large"] = "x2-large";
  MediaSize["X3Large"] = "x3-large";
  MediaSize["X4Large"] = "x4-large";
  return MediaSize;
}({});
var TextTags = /*#__PURE__*/function (TextTags) {
  TextTags["HeadingXXL"] = "h1";
  TextTags["HeadingXL"] = "h1";
  TextTags["Heading"] = "h1";
  TextTags["SectionHeading"] = "h2";
  TextTags["Title"] = "h2";
  TextTags["Subtitle"] = "h3";
  TextTags["Caption"] = "h4";
  TextTags["Body"] = "span";
  TextTags["UserInput"] = "span";
  return TextTags;
}({});

/* Temporary type for List until we unify Direction with Stack */

export { MediaSize, TextTags };
//# sourceMappingURL=types.js.map
